/**
 * The policy form's request body (PatientPolicyInfoFormModal).
 *
 * Fee guide, specialist fee and deductible have no inputs on that form any more
 * (they're entered in the Breakdowns tab's Plan details drawer), and antd's
 * validateFields returns only the fields on the form. A key that isn't there
 * must stay out of the request: sending it as null erased the stored answer
 * and locked it against the scrapers, on every save.
 */
const PLAN_FIELDS_OFF_FORM = ["fee_guide", "specialist_fee_covered", "deductible"];

export function stripUnmountedPlanFields(values) {
  const out = Object.assign({}, values);
  if (out.fee_guide !== undefined && out.fee_guide !== null && String(out.fee_guide).trim() === "") {
    out.fee_guide = null;
  }
  if (out.deductible === "") out.deductible = null;
  PLAN_FIELDS_OFF_FORM.forEach((key) => {
    if (out[key] === undefined) delete out[key];
  });
  return out;
}
